import React from "react";
import PodcastSection from "../components/PodcastSection/PodcastSection";

const PlacesRoute = () => {
  return (
    <>
      <div className="pt-14">
        <PodcastSection />
      </div>
    </>
  );
};

export default PlacesRoute;
